// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"fe0da722","453":"910f8b6b","611":"7cebe58c","713":"e19d2259","795":"e4fcb53c"}[chunkId] + ".chunk.js";
};